import { useState, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResultEntry = () => {
	const formRef = useRef(null)
	const scriptUrl = "https://script.google.com/macros/s/AKfycbyjidyHmh9Z1jK0ywEMA8p86fvYw2uCCfBwu7_9W2q65dFqyCusxM5Fe94zzs0b5M7xcA/exec"
	const [loading, setLoading] = useState(false)

	const handleSubmit = (e) => {
		e.preventDefault()
		setLoading(true)
		// console.log(formRef.current.getAll)

		fetch(scriptUrl, {
			method: 'POST',
			body: new FormData(formRef.current),
		})
		.then(res => {
			console.log("SUCCESSFULLY SUBMITTED")
			setLoading(false)
			formRef.current.reset();
			toast.success('Successfully Submitted', {
				position: "top-right",
				autoClose: 3000,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "dark",
			});
		})
		.catch((err) => {
			console.log(err);
			toast.error('Not Submitted', {
				position: "top-right",
				autoClose: 3000,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "dark",
			});
		})
	}

	return (
		<form ref={formRef} onSubmit={handleSubmit} name="Negative" className="my-8">

			<ToastContainer />

			<div className="mb-4">
				<label htmlFor='House' className="block font-medium mb-2">
					House
				</label>
				<select name="House" id="House" className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight" required>
					<option value="" id="" selected>--select--</option>
					<option value="Aryans" id="Aryans">Aryans</option>
					<option value="Mughals" id="Mughals">Mughals</option>
					<option value="Rajputs" id="Rajputs">Rajputs</option>
					<option value="Spartans" id="Spartans">Spartans</option>
					<option value="Vikings" id="Vikings">Vikings</option>
				</select>
			</div>

			<div className="mb-4">
				<label htmlFor='Score' className="block font-medium mb-2">
					Score
				</label>
				<input type="number" placeholder="example: -5" onWheel={(e) => e.target.blur()} id="Score" name="Score" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight" required />
			</div>

			<div className="mb-4">
				<label htmlFor='Remark' className="block font-medium mb-2">
					Remark
				</label>
				<input type="text" placeholder="State the cause of additional negative or positive score" onWheel={(e) => e.target.blur()} id="Remark" name="Remark" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight" />
			</div>

			<div className="mt-8">
				<input type="submit" value={loading ? "Loading..." : "SUBMIT"} className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-sm shadow-sm text-white bg-amber-500 hover:bg-amber-600" />
			</div>
		</form>
	)
}

export default ResultEntry;
